export const en = {
  'dashboard.title': 'Dashboard',
  'dashboard.description': 'How the gym is doing in the selected period.',
  'dashboard.setup.title': 'Finish setting up your gym',
  'dashboard.setup.stepsLeft.one': '{count} required step left before everything is live.',
  'dashboard.setup.stepsLeft.other': '{count} required steps left before everything is live.',
  'dashboard.setup.blockers': 'Activation blockers: {blockers}',
  'dashboard.step.basics': 'Gym profile',
  'dashboard.step.branding': 'Branding',
  'dashboard.step.domain': 'Domains',
  'dashboard.step.email': 'Email',
  'dashboard.step.payment': 'Payments',
  'dashboard.step.access': 'Access control',
  'dashboard.step.plans': 'Plans',
  'dashboard.step.trainers': 'Trainers',
  'dashboard.step.classes': 'Classes',
  'dashboard.step.website': 'Website',
  'dashboard.step.verification': 'Verification',
  'dashboard.hint.basics': 'Name, timezone and currency',
  'dashboard.hint.branding': 'Upload a logo and pick brand colours',
  'dashboard.hint.domain': 'A verified subdomain or custom domain',
  'dashboard.hint.email': 'Connect SMTP or Resend so members receive email',
  'dashboard.hint.payment': 'Connect and test TBC or BOG',
  'dashboard.hint.paymentWithMock': 'Connect and test TBC, BOG or the mock provider',
  'dashboard.hint.access': 'Connect the access-control provider and map readers',
  'dashboard.hint.plans': 'At least one membership plan',
  'dashboard.hint.trainers': 'Add trainers for the website and classes',
  'dashboard.hint.classes': 'Add classes and weekly schedules',
  'dashboard.hint.website': 'Publish the public website',
  'dashboard.hint.verification': 'Every enabled integration passes its connection test',
  'dashboard.activeMembers': 'Active members',
  'dashboard.newMembers': 'New members',
  'dashboard.inPeriod': 'In the selected period',
  'dashboard.expiringSoon': 'Expiring in 7 days',
  'dashboard.revenue': 'Revenue',
  'dashboard.paidInPeriod': 'Paid in the selected period',
  'dashboard.upcomingSessions': 'Upcoming sessions',
  'dashboard.bookingsToday': 'Bookings today',
  'dashboard.attendanceToday': 'Attendance today',
  'dashboard.accessEventsToday': 'Access events today',
  'dashboard.deniedCount': '{count} denied',
  'dashboard.noDenials': 'No denials',
  'dashboard.countedAt': 'Money, classes and door taps are counted at {branches}. Members belong to every branch, so member counts are the whole gym’s.',
  'dashboard.recentPayments': 'Recent payments',
  'dashboard.allPayments': 'All payments',
  'dashboard.noPayments': 'No payments yet',
  'dashboard.noPaymentsHint': 'Payments show up here as members buy memberships.',
  'dashboard.member': 'Member',
  'dashboard.amount': 'Amount',
  'dashboard.integrations': 'Integrations',
  'dashboard.manage': 'Manage',
  'dashboard.noIntegrations': 'No integrations configured yet.',

  'memberships.title': 'Memberships',
  'memberships.description': 'Every plan assigned to a member, with its lifecycle.',
  'memberships.anyStatus': 'Any status',
  'memberships.expiringSoon': 'Expiring within 7 days',
  'memberships.showDeleted': 'Deleted',
  'memberships.deletedOn': 'Deleted on',
  'memberships.deletedBy': 'Deleted by',
  'memberships.deleteReason': 'Reason',
  'memberships.restore': 'Restore',
  'memberships.restored': 'Membership restored',
  'memberships.emptyDeleted': 'No deleted memberships',
  'memberships.emptyDeletedHint': 'A deleted membership stays here for the record and can be restored for 7 days.',
  'memberships.add': 'Add membership',
  'memberships.addTitle': 'Add a membership',
  'memberships.addDescription': 'Find the member, then give the membership without payment or sell it.',
  'memberships.empty': 'No memberships',
  'memberships.emptyExpiring': 'Nothing expires in the next week.',
  'memberships.emptyHint': 'Assign a plan from a member’s profile to see it here.',
  'memberships.plan': 'Plan',
  'memberships.member': 'Member',
  'memberships.starts': 'Starts',
  'memberships.ends': 'Ends',
  'memberships.visits': 'Visits',
  'memberships.viewMember': 'View member',
  'memberships.pauses.title': 'Freeze requests',
  'memberships.pauses.description': 'Members asked to freeze their membership and are waiting for a decision.',
  'memberships.pauses.requested': 'requested {date}',
  'memberships.pauses.requestedWithReason': '“{reason}” · requested {date}',
  'memberships.pauses.approve': 'Approve',
  'memberships.pauses.reject': 'Reject',
  'memberships.pauses.approved': 'Freeze approved',
  'memberships.pauses.rejected': 'Freeze rejected',

  'plans.admin.title': 'Plans',
  'plans.admin.description': 'Membership products members can buy or be assigned.',
  'plans.admin.showArchived': 'Show archived',
  'plans.admin.new': 'New plan',
  'plans.admin.empty': 'No plans yet',
  'plans.admin.emptyHint': 'Create your first membership plan so members can join.',
  'plans.admin.create': 'Create plan',
  'plans.admin.summary': '{duration} · {billing}',
  'plans.admin.badge.archived': 'Archived',
  'plans.admin.badge.notPurchasable': 'Not purchasable',
  'plans.admin.badge.classesIncluded': 'Classes included',
  'plans.admin.badge.gymFloorOnly': 'Gym floor only',
  'plans.admin.badge.perWeek': '{count}/week',
  'plans.admin.badge.noPauses': 'No freezes',
  'plans.admin.badge.unlimited': 'Unlimited visits',
  'plans.admin.badge.visits.one': '{count} visit',
  'plans.admin.badge.visits.other': '{count} visits',
  'plans.admin.badge.perDay': '{count}/day',
  'plans.admin.field.hours': 'Hours',
  'plans.admin.field.visits': 'Visits',
  'plans.admin.hours.any': 'Any time',
  'plans.admin.hours.certain': 'Certain hours',
  'plans.admin.hours.anyHint': 'Whenever the gym is open.',
  'plans.admin.hours.order': 'Must be later than the start',
  'plans.admin.visits.unlimited': 'Unlimited',
  'plans.admin.visits.limited': 'A number of visits',
  'plans.admin.visits.required': 'Enter how many visits',
  'plans.admin.visibility.PUBLIC': 'Public',
  'plans.admin.visibility.HIDDEN': 'Hidden',
  'plans.admin.archive': 'Archive',
  'plans.admin.restore': 'Restore',
  'plans.admin.archivedToast': 'Plan archived',
  'plans.admin.restoredToast': 'Plan restored',
  'plans.admin.updated': 'Plan updated',
  'plans.admin.created': 'Plan created',
  'plans.admin.editTitle': 'Edit {name}',
  'plans.admin.saveChanges': 'Save changes',
  'plans.admin.editors.marketing': 'Marketing can edit plans too',
  'plans.admin.editors.hint': 'Owners, admins and gym general managers always can.',
  'plans.admin.editors.on': 'Marketing can now edit plans',
  'plans.admin.editors.off': 'Marketing can no longer edit plans',
  'plans.admin.section.basics': 'Basics',
  'plans.admin.section.access': 'Access rules',
  'plans.admin.section.pause': 'Freeze rules',
  'plans.admin.field.displayName': 'Display name',
  'plans.admin.field.displayNameHint': 'Shown on the website in each language.',
  'plans.admin.field.description': 'Description',
  'plans.admin.field.descriptionLocalized': 'Display description',
  'plans.admin.field.descriptionLocalizedHint': 'Shown on the website and in the member area in each language.',
  'plans.admin.field.price': 'Price ({currency})',
  'plans.admin.field.duration': 'Duration (days)',
  'plans.admin.field.billing': 'Billing',
  'plans.admin.field.visibility': 'Visibility',
  'plans.admin.field.bookingsPerWeek': 'Bookings per week',
  'plans.admin.field.emptyUnlimited': 'Empty = unlimited',
  'plans.admin.field.sortOrder': 'Sort order',
  'plans.admin.field.groupClasses': 'Group classes included',
  'plans.admin.field.purchasable': 'Purchasable online',
  'plans.admin.field.autoRenew': 'Auto-renew',
  'plans.admin.field.allowedWeekdays': 'Allowed weekdays',
  'plans.admin.field.until': 'Until',
  'plans.admin.field.visitsPerDay': 'Visits per day',
  'plans.admin.field.totalVisits': 'Total visits',
  'plans.admin.field.accessZones': 'Access zones',
  'plans.admin.field.accessZonesHint': 'Leave all unchecked to allow every zone.',
  'plans.admin.field.pausable': 'Can be frozen',
  'plans.admin.field.maxPauseDays': 'Max freeze days',
  'plans.admin.field.maxPauses': 'Max freezes',
  'plans.admin.field.emptyGymDefault': 'Empty = gym default',
  'plans.admin.field.needsApproval': 'Needs staff approval',
  'plans.admin.field.gymDefault': 'Gym default',
  'enum.billingInterval.ONE_TIME': 'One time',
  'enum.billingInterval.MONTHLY': 'Monthly',
  'enum.billingInterval.YEARLY': 'Yearly',
};

export const ka: Record<keyof typeof en, string> = {
  'dashboard.title': 'მთავარი დაფა',
  'dashboard.description': 'დარბაზის მაჩვენებლები არჩეულ პერიოდში.',
  'dashboard.setup.title': 'დაასრულეთ დარბაზის დაყენება',
  'dashboard.setup.stepsLeft.one': 'სანამ ყველაფერი ამოქმედდება, დარჩა {count} სავალდებულო ნაბიჯი.',
  'dashboard.setup.stepsLeft.other': 'სანამ ყველაფერი ამოქმედდება, დარჩა {count} სავალდებულო ნაბიჯი.',
  'dashboard.setup.blockers': 'აქტივაციას აფერხებს: {blockers}',
  'dashboard.step.basics': 'დარბაზის პროფილი',
  'dashboard.step.branding': 'ბრენდინგი',
  'dashboard.step.domain': 'დომენები',
  'dashboard.step.email': 'ელფოსტა',
  'dashboard.step.payment': 'გადახდები',
  'dashboard.step.access': 'დაშვების კონტროლი',
  'dashboard.step.plans': 'პაკეტები',
  'dashboard.step.trainers': 'ტრენერები',
  'dashboard.step.classes': 'ვარჯიშები',
  'dashboard.step.website': 'ვებსაიტი',
  'dashboard.step.verification': 'გადამოწმება',
  'dashboard.hint.basics': 'სახელი, სასაათო სარტყელი და ვალუტა',
  'dashboard.hint.branding': 'ატვირთეთ ლოგო და აირჩიეთ ბრენდის ფერები',
  'dashboard.hint.domain': 'დადასტურებული ქვედომენი ან საკუთარი დომენი',
  'dashboard.hint.email': 'დააკავშირეთ SMTP ან Resend, რომ წევრებმა ელფოსტა მიიღონ',
  'dashboard.hint.payment': 'დააკავშირეთ და შეამოწმეთ TBC ან BOG',
  'dashboard.hint.paymentWithMock': 'დააკავშირეთ და შეამოწმეთ TBC, BOG ან სატესტო (mock) პროვაიდერი',
  'dashboard.hint.access': 'დააკავშირეთ დაშვების კონტროლის პროვაიდერი და მიაბით წამკითხველები',
  'dashboard.hint.plans': 'მინიმუმ ერთი აბონემენტის პაკეტი',
  'dashboard.hint.trainers': 'დაამატეთ ტრენერები ვებსაიტისა და ვარჯიშებისთვის',
  'dashboard.hint.classes': 'დაამატეთ ვარჯიშები და კვირის განრიგი',
  'dashboard.hint.website': 'გამოაქვეყნეთ საჯარო ვებსაიტი',
  'dashboard.hint.verification': 'ყველა ჩართული ინტეგრაცია გადის კავშირის შემოწმებას',
  'dashboard.activeMembers': 'აქტიური წევრები',
  'dashboard.newMembers': 'ახალი წევრები',
  'dashboard.inPeriod': 'არჩეულ პერიოდში',
  'dashboard.expiringSoon': 'ვადა იწურება 7 დღეში',
  'dashboard.revenue': 'შემოსავალი',
  'dashboard.paidInPeriod': 'გადახდილია არჩეულ პერიოდში',
  'dashboard.upcomingSessions': 'მომავალი სესიები',
  'dashboard.bookingsToday': 'დღევანდელი ჯავშნები',
  'dashboard.attendanceToday': 'დღევანდელი დასწრება',
  'dashboard.accessEventsToday': 'დღევანდელი დაშვების მოვლენები',
  'dashboard.deniedCount': '{count} უარი',
  'dashboard.noDenials': 'უარი არ ყოფილა',
  'dashboard.countedAt': 'თანხები, ვარჯიშები და შესვლები დათვლილია აქ: {branches}. წევრები ყველა ფილიალს ეკუთვნის, ამიტომ წევრების რაოდენობა მთელი დარბაზისაა.',
  'dashboard.recentPayments': 'ბოლო გადახდები',
  'dashboard.allPayments': 'ყველა გადახდა',
  'dashboard.noPayments': 'გადახდები ჯერ არ არის',
  'dashboard.noPaymentsHint': 'გადახდები აქ გამოჩნდება, როცა წევრები აბონემენტებს შეიძენენ.',
  'dashboard.member': 'წევრი',
  'dashboard.amount': 'თანხა',
  'dashboard.integrations': 'ინტეგრაციები',
  'dashboard.manage': 'მართვა',
  'dashboard.noIntegrations': 'ინტეგრაციები ჯერ არ არის დაყენებული.',

  'memberships.title': 'აბონემენტები',
  'memberships.description': 'წევრებისთვის მინიჭებული ყველა პაკეტი და მისი სასიცოცხლო ციკლი.',
  'memberships.anyStatus': 'ნებისმიერი სტატუსი',
  'memberships.expiringSoon': 'ვადა იწურება 7 დღეში',
  'memberships.showDeleted': 'წაშლილები',
  'memberships.deletedOn': 'წაშლის თარიღი',
  'memberships.deletedBy': 'წაშალა',
  'memberships.deleteReason': 'მიზეზი',
  'memberships.restore': 'აღდგენა',
  'memberships.restored': 'აბონემენტი აღდგა',
  'memberships.emptyDeleted': 'წაშლილი აბონემენტები არ არის',
  'memberships.emptyDeletedHint': 'წაშლილი აბონემენტი აქ ჩანაწერისთვის რჩება და 7 დღის განმავლობაში აღდგენა შეიძლება.',
  'memberships.add': 'აბონემენტის დამატება',
  'memberships.addTitle': 'აბონემენტის დამატება',
  'memberships.addDescription': 'იპოვეთ წევრი, შემდეგ გასცეთ აბონემენტი უფასოდ ან გაყიდეთ.',
  'memberships.empty': 'აბონემენტები არ არის',
  'memberships.emptyExpiring': 'მომდევნო კვირაში არცერთ აბონემენტს ვადა არ ეწურება.',
  'memberships.emptyHint': 'მიანიჭეთ პაკეტი წევრის პროფილიდან და ის აქ გამოჩნდება.',
  'memberships.plan': 'პაკეტი',
  'memberships.member': 'წევრი',
  'memberships.starts': 'იწყება',
  'memberships.ends': 'მთავრდება',
  'memberships.visits': 'ვიზიტები',
  'memberships.viewMember': 'წევრის ნახვა',
  'memberships.pauses.title': 'გაყინვის მოთხოვნები',
  'memberships.pauses.description': 'წევრებმა აბონემენტის გაყინვა მოითხოვეს და გადაწყვეტილებას ელოდებიან.',
  'memberships.pauses.requested': 'მოთხოვნილია {date}',
  'memberships.pauses.requestedWithReason': '„{reason}“ · მოთხოვნილია {date}',
  'memberships.pauses.approve': 'დამტკიცება',
  'memberships.pauses.reject': 'უარყოფა',
  'memberships.pauses.approved': 'გაყინვა დამტკიცდა',
  'memberships.pauses.rejected': 'გაყინვა უარყოფილია',

  'plans.admin.title': 'პაკეტები',
  'plans.admin.description': 'აბონემენტის პაკეტები, რომლებსაც წევრები ყიდულობენ ან რომლებიც მათ ენიჭებათ.',
  'plans.admin.showArchived': 'დაარქივებულების ჩვენება',
  'plans.admin.new': 'ახალი პაკეტი',
  'plans.admin.empty': 'პაკეტები ჯერ არ არის',
  'plans.admin.emptyHint': 'შექმენით პირველი აბონემენტის პაკეტი, რომ წევრებმა გაწევრიანება შეძლონ.',
  'plans.admin.create': 'პაკეტის შექმნა',
  'plans.admin.summary': '{duration} · {billing}',
  'plans.admin.badge.archived': 'დაარქივებული',
  'plans.admin.badge.notPurchasable': 'არ იყიდება',
  'plans.admin.badge.classesIncluded': 'ვარჯიშები შედის',
  'plans.admin.badge.gymFloorOnly': 'მხოლოდ დარბაზი',
  'plans.admin.badge.perWeek': '{count}/კვირაში',
  'plans.admin.badge.noPauses': 'გაყინვის გარეშე',
  'plans.admin.badge.unlimited': 'ულიმიტო ვიზიტები',
  'plans.admin.badge.visits.one': '{count} ვიზიტი',
  'plans.admin.badge.visits.other': '{count} ვიზიტი',
  'plans.admin.badge.perDay': '{count}/დღეში',
  'plans.admin.field.hours': 'საათები',
  'plans.admin.field.visits': 'ვიზიტები',
  'plans.admin.hours.any': 'ნებისმიერ დროს',
  'plans.admin.hours.certain': 'გარკვეულ საათებში',
  'plans.admin.hours.anyHint': 'როცა დარბაზი ღიაა.',
  'plans.admin.hours.order': 'დაწყების შემდეგ უნდა იყოს',
  'plans.admin.visits.unlimited': 'ულიმიტო',
  'plans.admin.visits.limited': 'ვიზიტების რაოდენობა',
  'plans.admin.visits.required': 'მიუთითეთ ვიზიტების რაოდენობა',
  'plans.admin.visibility.PUBLIC': 'საჯარო',
  'plans.admin.visibility.HIDDEN': 'დამალული',
  'plans.admin.archive': 'დაარქივება',
  'plans.admin.restore': 'აღდგენა',
  'plans.admin.archivedToast': 'პაკეტი დაარქივდა',
  'plans.admin.restoredToast': 'პაკეტი აღდგა',
  'plans.admin.updated': 'პაკეტი განახლდა',
  'plans.admin.created': 'პაკეტი შეიქმნა',
  'plans.admin.editTitle': 'რედაქტირება: {name}',
  'plans.admin.saveChanges': 'ცვლილებების შენახვა',
  'plans.admin.editors.marketing': 'მარკეტინგსაც შეუძლია პაკეტების რედაქტირება',
  'plans.admin.editors.hint': 'მფლობელს, ადმინისტრატორს და დარბაზის გენერალურ მენეჯერს ყოველთვის შეუძლიათ.',
  'plans.admin.editors.on': 'მარკეტინგს ახლა შეუძლია პაკეტების რედაქტირება',
  'plans.admin.editors.off': 'მარკეტინგს აღარ შეუძლია პაკეტების რედაქტირება',
  'plans.admin.section.basics': 'ძირითადი',
  'plans.admin.section.access': 'დაშვების წესები',
  'plans.admin.section.pause': 'გაყინვის წესები',
  'plans.admin.field.displayName': 'საჩვენებელი სახელი',
  'plans.admin.field.displayNameHint': 'ვებსაიტზე ჩანს თითოეულ ენაზე.',
  'plans.admin.field.description': 'აღწერა',
  'plans.admin.field.descriptionLocalized': 'საჩვენებელი აღწერა',
  'plans.admin.field.descriptionLocalizedHint': 'ვებსაიტზე და წევრის გვერდზე ჩანს თითოეულ ენაზე.',
  'plans.admin.field.price': 'ფასი ({currency})',
  'plans.admin.field.duration': 'ხანგრძლივობა (დღე)',
  'plans.admin.field.billing': 'გადახდის პერიოდულობა',
  'plans.admin.field.visibility': 'ხილვადობა',
  'plans.admin.field.bookingsPerWeek': 'ჯავშნები კვირაში',
  'plans.admin.field.emptyUnlimited': 'ცარიელი = ულიმიტო',
  'plans.admin.field.sortOrder': 'რიგითობა',
  'plans.admin.field.groupClasses': 'ჯგუფური ვარჯიშები შედის',
  'plans.admin.field.purchasable': 'იყიდება ონლაინ',
  'plans.admin.field.autoRenew': 'ავტომატური გაგრძელება',
  'plans.admin.field.allowedWeekdays': 'დაშვებული კვირის დღეები',
  'plans.admin.field.until': 'მდე',
  'plans.admin.field.visitsPerDay': 'ვიზიტები დღეში',
  'plans.admin.field.totalVisits': 'ვიზიტები სულ',
  'plans.admin.field.accessZones': 'დაშვების ზონები',
  'plans.admin.field.accessZonesHint': 'დატოვეთ ყველა მოუნიშნავი, რომ ყველა ზონაში იყოს დაშვება.',
  'plans.admin.field.pausable': 'შესაძლებელია გაყინვა',
  'plans.admin.field.maxPauseDays': 'გაყინვის მაქს. დღეები',
  'plans.admin.field.maxPauses': 'გაყინვების მაქს. რაოდენობა',
  'plans.admin.field.emptyGymDefault': 'ცარიელი = დარბაზის ნაგულისხმევი',
  'plans.admin.field.needsApproval': 'საჭიროებს პერსონალის დამტკიცებას',
  'plans.admin.field.gymDefault': 'დარბაზის ნაგულისხმევი',
  'enum.billingInterval.ONE_TIME': 'ერთჯერადი',
  'enum.billingInterval.MONTHLY': 'ყოველთვიური',
  'enum.billingInterval.YEARLY': 'ყოველწლიური',
};
